import React, { useState } from 'react';
import {sendPasswordResetEmail} from "../auth";

const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const handleForgotPassword = async () => {
        setError('');
        setMessage('');
        if (!email) {
            setError('Veuillez entrer votre adresse email.');
            return;
        }
        if (!/\S+@\S+\.\S+/.test(email)) {
            setError('Adresse email invalide.');
            return;
        }

        try {
            // Appeler l'API pour envoyer un email de réinitialisation
            // Ici, une fonction simulée, tu dois implémenter ton API
            await sendPasswordResetEmail(email); // Remplacer par une vraie fonction

            setMessage('Un email de réinitialisation a été envoyé à votre adresse.');
        } catch (error) {
            setError('Erreur lors de l\'envoi de l\'email. Veuillez réessayer.');
        }
    };

    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100">
            <div className="absolute top-0 left-0 w-full h-full bg-white opacity-80" />
            <div className="w-full max-w-lg p-8 bg-white rounded-lg shadow-lg relative z-10 sm:p-6 md:p-8 lg:p-10">
                <div className="text-center mb-8">
                    <h2 className="text-xl sm:text-lg md:text-2xl lg:text-3xl font-semibold text-gray-700">
                        Réinitialisation du mot de passe
                    </h2>
                </div>
                {error && (
                    <div className="text-red-600 mb-4 text-center font-medium">
                        {error}
                    </div>
                )}
                {message && (
                    <div className="text-green-600 mb-4 text-center font-medium">
                        {message}
                    </div>
                )}
                <div className="mb-4">
                    <label className="block text-gray-600 font-medium">
                        Email
                    </label>
                    <input
                        type="email"
                        className="w-full p-3 mt-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-600 focus:border-transparent"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Entrez votre email"
                    />
                </div>
                <button
                    onClick={handleForgotPassword}
                    className="w-full py-3 bg-gray-700 text-white rounded-md font-medium text-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-600 focus:ring-opacity-50"
                >
                    Envoyer l'email
                </button>
            </div>
        </div>
    );
};

export default ForgotPassword;
